import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PlacementList = lazy(() =>
  import("@scenes/Placements/PlacementList/PlacementList").then((module) => ({
    default: module.PlacementList,
  }))
);

export const placementsNRO: NavigationRoutingObject = {
  Component: PlacementList,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("placements-nro-heading", "Banner Placements"),
  pageNameForTracking: () => "Banner Placements",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("placements-nro-description", "Manage the placement of banner campaigns"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("banners") &&
      (hasPermission("appGroup", { permission: "basicReadOnly" }) ||
        hasPermission("appGroup", { permission: "viewPlacements" }))
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
